import { CheckCircle2 } from "lucide-react";

export default function SafeResultCard({ query }) {
  return (
    <div
      data-testid="safe-result-card"
      className="fade-up bg-green-50 border-2 border-green-500 rounded-2xl p-6 sm:p-8 shadow-sm w-full max-w-3xl mx-auto text-right"
    >
      <div className="flex flex-col md:flex-row gap-6 items-start">
        <div className="w-16 h-16 shrink-0 text-green-600 bg-green-100 rounded-full flex items-center justify-center">
          <CheckCircle2 className="w-8 h-8" strokeWidth={2.5} />
        </div>
        <div className="flex-1">
          <div className="inline-flex items-center gap-2 bg-green-600 text-white text-sm font-bold tracking-tight px-3 py-1 rounded-full mb-3">
            <span>غير مدرج في قائمة التقييد</span>
          </div>
          <h2 className="text-2xl sm:text-3xl font-bold text-green-900 mb-2 break-words">
            «{query}» لا يظهر ضمن الأدوية المقيدة
          </h2>
          <p className="text-lg text-green-800 leading-relaxed">
            لم نعثر على هذا الاسم في قاعدة بيانات. يُنصح دائمًا باستشارة طبيبك أو الصيدلي قبل استخدام أي دواء، حتى لو لم يكن ضمن قائمة التقييد أو الاتصال على وزارة الصحة رقم <a href="tel:973" className="font-bold underline">973</a>.
          </p>
          <p className="text-sm text-green-700 mt-3 leading-relaxed" data-testid="safe-result-disclaimer">
            نحن نُخلي مسؤوليتنا، ونوصي باستشارة طبيب مختص.
          </p>
        </div>
      </div>
    </div>
  );
}
